import React from 'react'
import styled from 'styled-components'
import { useRevealProps } from '../../MwPage/components/Reveal'
import { dark, Eyebrow, Hi, ink, Lede, onDark, sans, Section, SectionHead, Small, Stack } from '../../MwPage/styled'
import TrialCta from '../components/TrialCta'
import { useFocus } from '../focus'
import { Bullets, Card, Column, Grid, H2, Kicker, Wrap } from '../styled'
import { ProgrammeCard } from './TransformationSection'

// the prototype's .vs: today beside day 30, the day-30 card dark
const Side = styled(Card)`
  ${(props) =>
    props.$dark &&
    `
    background: ${dark};
    border-color: ${dark};
    color: ${onDark};

    h3 { color: #ffffff; }
    li { color: ${onDark}; }
  `}

  h3 {
    margin: 0 0 10px;
    font-size: 20px;
  }
`

const Closer = styled.p`
  margin: 0;
  font: 800 clamp(1.3rem, 2.4vw, 1.6rem) / 1.25 ${sans};
  letter-spacing: -0.03em;
  color: ${ink};
`

const RevealEyebrow = ({ children }) => <Eyebrow {...useRevealProps()}>{children}</Eyebrow>

const SideCard = ({ side, dark }) => (
  <Side $dark={dark} {...useRevealProps()}>
    <Kicker>{side.kicker}</Kicker>
    <h3>{side.title}</h3>
    <Bullets $ok={dark}>
      {side.items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </Bullets>
  </Side>
)

/** "Your 30 days": today against day 30 as two lists, then "Your … plan starts here", the Jumpstart card and the trial button. */
const TrialTransformationSection = ({ offer }) => {
  const { transformation } = useFocus()
  const { today, day30, after } = transformation

  return (
    <>
      <Section $ice>
        <Wrap>
          <Stack $gap="clamp(24px, 3vw, 32px)">
            <SectionHead>
              <Eyebrow {...useRevealProps()}>{transformation.eyebrow}</Eyebrow>
              <H2 {...useRevealProps()}>
                {transformation.headline} <Hi>{transformation.headlineAccent}</Hi>
              </H2>
            </SectionHead>
            <Column $max={820} $gap={22}>
              <Grid $min={260}>
                <SideCard side={today} />
                <SideCard side={day30} dark />
              </Grid>
              <Closer {...useRevealProps()}>
                {transformation.closer}
                <Hi>{transformation.closerAccent}</Hi>
              </Closer>
            </Column>
          </Stack>
        </Wrap>
      </Section>
      <Section>
        <Wrap>
          <Stack $gap="clamp(24px, 3vw, 32px)">
            <SectionHead>
              {after.eyebrow && <RevealEyebrow>{after.eyebrow}</RevealEyebrow>}
              <H2 {...useRevealProps()}>
                {after.headline} <Hi>{after.headlineAccent}</Hi>
              </H2>
              <Lede {...useRevealProps()}>{after.lede}</Lede>
            </SectionHead>
            <Column $max={820} $gap={22}>
              {after.programmes.map((programme) => (
                <ProgrammeCard key={programme.title} programme={programme} price={offer.price} />
              ))}
              <Small {...useRevealProps()}>{after.note}</Small>
              <div {...useRevealProps()}>
                <TrialCta offer={offer} block line="fine" />
              </div>
            </Column>
          </Stack>
        </Wrap>
      </Section>
    </>
  )
}

export default TrialTransformationSection
